module.exports = __webpack_public_path__ + "static/media/M.fef41206.jpg";